import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { getMortarProData } from '@/service/production/ProReportMortar';
export default function useProData(date) {
  var sandData = ref({
    totalSettleValue: 0,
    totalAveragePrice: 0,
    receivingList: [],
    totalMoney: 0,
    totalSingular: 0
  });
  var list = ref([]);
  // 获取制砂总汇
  var getMortarProDataAsyc = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMortarProData(date.value);
          case 2:
            data = _context.sent;
            sandData.value = data;
            list.value = data.receivingList;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getMortarProDataAsyc() {
      return _ref.apply(this, arguments);
    };
  }();
  var receiveData = computed(function () {
    return {
      pieData: list.value.map(function (item) {
        return {
          name: item.stone_name,
          value: item.release_nums
        };
      }).filter(function (item) {
        return item.value;
      }),
      unit: '吨',
      customTooltip: true,
      tooltipFormatter: function tooltipFormatter(params) {
        return "\n          <div >\n            <div class=\"flex align-start\">\n              <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n              <div>\n                <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                <div>\n                 <span style=\"font-size: 12px;\">").concat(params.value, "\u5428</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          ");
      }
    };
  });
  return [sandData, receiveData, getMortarProDataAsyc];
}